export default __webpack_public_path__ + "static/mob-retail-android-898975d58ead0dff448ee1357743121c.png";